import React from "react";

// Icon utilizado para erro
export const CircleX = ({width, height, strokeWidth}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#ff0000"
      stroke-width={strokeWidth} // Espessura do Icone
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-circle-x"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="m15 9-6 6" />
      <path d="m9 9 6 6" />
    </svg>
  );
};

// Icon utilizado para confirmação
const CircleCheck = ({width, height, strokeWidth}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 48 49"
    >
      <path
        stroke="var(--success-color)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}// Espessura do Icone
        d="M24 44.268c11.046 0 20-8.955 20-20 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 11.045 8.954 20 20 20zM21.344 29.612L33.2 17.768M21.344 29.612L14.8 23.646"
      ></path>
    </svg>
  );
};

export default CircleCheck;
